import React, { useEffect } from "react";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import { useLocation, useNavigate } from "react-router-dom";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { useDispatch } from "react-redux";
import ICONS from "../../../../assets/Icons";

const UserError = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (!state) {
      navigate("/home", { replace: true });
    }
  }, []);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const buttonRows = [
    [
      {
        btnText: "Create new user",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: ICONS?.ADD_BUTTON_WHITE,
        handleFunction: () => {
          navigate("/settings/users/create_user");
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--negative-bg)",
        outLineColor: "var(--text-primary)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--negative-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => {
          navigate("/home");
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "white",
      },
    ],
  ];

  return (
    <StatusContainer
      status="error"
      buttonRows={buttonRows}
      title="User creation failed."
    >
      <TabsWeapperSection title="Error">
        <>
          {Object.keys(state?.error?.errors).map((key) => (
            <InfoCard
              bgColor="var(--negative-card)"
              rows={[
                {
                  leftTitle: state?.error?.errors[key],
                  leftSubTitle: "Error message",
                },
              ]}
            />
          ))}
        </>
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default UserError;
